import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import DocumentControlReporting from "./DocumentControlReporting.jsx";
import { fetchDocument } from "./redux/actions.js";



const DocumentControl = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(fetchActivityTypes({ page: 1, limit: 100, search: {} }));
    dispatch(fetchDocument());
  }, []);
  
  return (
    <div className="page-top-div">
      <span className="text-span">DOCUMENT CONTROL - COE0005 </span>
      <DocumentControlReporting/>
    </div>
  );
};

export default DocumentControl;
